import { render } from "./HomeOrderCalculator.vue?vue&type=template&id=6a294d2c&scoped=true"
import script from "./HomeOrderCalculator.vue?vue&type=script&lang=js"
export * from "./HomeOrderCalculator.vue?vue&type=script&lang=js"

import "./HomeOrderCalculator.vue?vue&type=style&index=0&id=6a294d2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a294d2c"]])

export default __exports__